/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

if (n === 0)
    return 0;
if (n === 1)
    return 1;
return 5;
}

export default ["blo",[["1ka","2ja"],u,["ʊshilè kʊboɖu","ʊshilè kʊsasʊ"]],[["1ka","2ja"]],[["lh","ɖt","tl","lr","lm","rs","sb"],["alah","aɖɩt","atal","alar","alam","arɩs","asib"],["alahaɖɩ","aɖɩtɛnɛɛ","atalaata","alaarba","alaamɩshɩ","arɩsǝma","asiibi"],["alh","aɖt","atl","alr","alm","ars","asb"]],u,[["1","2","3","4","5","6","7","8","9","10","11","12"],["kaw","kpa","ci","ɖʊ","ɖu5","ɖu6","la","kǝu","fʊm","cim","pom","bʊn"],["ɩjikawǝrka kaŋɔrɔ","ɩjikpaka kaŋɔrɔ","arɛ́cika kaŋɔrɔ","njɩbɔ nɖʊka kaŋɔrɔ","acafʊnɖuka kaŋɔrɔ","anɔɔɖuka kaŋɔrɔ","alàlaka kaŋɔrɔ","ɩjikǝuka kaŋɔrɔ","abofʊmka kaŋɔrɔ","ɩjicimka kaŋɔrɔ","acapomka kaŋɔrɔ","anɔɔbʊnka kaŋɔrɔ"]],u,[["naaBYŊAƖ","AƖAK"],u,["naa Ba Ye Ŋʊm Annabi Ɩsa","Annabi Ɩsa Abʊŋʊma Kaŋkǝm"]],1,[6,0],["M/d/y","MMM d y","MMMM d y","EEEE, MMMM d y"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1}, {0}",u,u,u],[","," ",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","% #,#0;% -#,#0","¤ #,##0.00;¤ -#,##0.00","#E0"],"XOF","F CFA","Garɩɖontǝna gɩteŋshilelaŋ kasɛɛfa",{"JPY":["JP¥","¥"],"USD":["US$","$"]},"ltr", plural];
